'use client';
import 'client-only';

import { ToolsDiagnosticFeature } from '../common/features/tools-diagnostic-feature';
import { createUseFlag } from './create-use-flag';

export const useToolsDiagnosticFeature = createUseFlag(ToolsDiagnosticFeature);
